/* eslint-disable @typescript-eslint/no-unused-vars */
import { MiniProgrammeCard, PortalMap, PortalType, PublicMiniProgrammeCardClient } from "@studyportals/domain-client";

declare const DOMAIN_API_URL: string;

export class StudyClient {
	private client: PublicMiniProgrammeCardClient;

	constructor() {
		let portalMap = new Map<PortalType, string>();
		if( window['PortalMap']) {
			portalMap = new Map(Object.entries(window['PortalMap'] as Record<PortalType, string>)) as PortalMap;
		}

		this.client = new PublicMiniProgrammeCardClient(
			DOMAIN_API_URL,
			1,
			undefined,
			portalMap
		);

	}

	public async getMiniCard(studyId: number): Promise<MiniProgrammeCard> {
		return this.client.fetch(studyId);
	}
}
